<template>
  <div class="app" id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
</style>

<style scoped lang='scss'>
.app {
  height: 100%;
  width: 100%;
  overflow: auto;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}
/* 移动设备（小于768px） */
@media (max-width: 767px) {
  /* CSS样式 */
  .app {
    background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(18, 47, 74, 0.59) 59%,
        rgba(14, 43, 71, 0.6) 60%,
        rgba(2, 9, 16, 1) 100%
      ),
      url("../fgfRegister/images/BG_h5.png");
  }
}

/* 平板设备（768px 到 1024px） */
@media (min-width: 768px) and (max-width: 1024px) {
  /* CSS样式 */
  .app {
    background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(14, 43, 71, 0.6) 48%,
        rgba(2, 9, 16, 1) 100%
      ),
      url("../fgfRegister/images/BG_pad.png");
  }
  /* 竖屏 */
  @media all and (orientation: portrait) {
    .app {
      background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(18, 47, 74, 0.59) 59%,
          rgba(14, 43, 71, 0.6) 60%,
          rgba(2, 9, 16, 1) 100%
        ),
        url("../fgfRegister/images/BG_pad_vertical.png");
    }
  }
}

/* 桌面设备（大于等于1025px） */
@media (min-width: 1025px) {
  /* CSS样式 */
  .app {
    padding-top: 8rem;
    background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(14, 43, 71, 0.6) 48%,
        rgba(2, 9, 16, 1) 100%
      ),
      url("../fgfRegister/images/BG_web.png");
  }
}

/* 横屏 */
@media all and (orientation: landscape) {
}
</style>



// WEBPACK FOOTER //
// index.vue?67d6fa90